import { createContext, useContext } from 'react';

interface WidgetCardContextType {
  cardHeaderHeight: number;
}

export const WidgetCardContext = createContext<WidgetCardContextType>({ cardHeaderHeight: 0 });

export const useWidgetCard = () => useContext(WidgetCardContext);
